/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {WildNudgeServerDataParser} from "../WildNudgeServerDataParser";
import {IWildNudgeGameData} from "./IWildNudgeServerData";

export class WildNudgeParsedGameData extends SpinParsedGameData implements INudgeParsedGameData {

    private readonly _stackedSpinTriggered:boolean;
    private readonly _activeStackedSymbol:string;
    private readonly _initialStackOverlay:boolean[];
    private readonly _stackOverlay:boolean[][];
    private readonly _doReelNudge:boolean[];
    private readonly _doScatterNudge:boolean[];
    private readonly _extraSymbolsOnTop:string[][];
    private readonly _stackedModeSymbolInWin:boolean[];

    public get stackedSpinTriggered():boolean {
        return this._stackedSpinTriggered;
    }

    public get activeStackedSymbol():string {
        return this._activeStackedSymbol;
    }

    public get initialStackOverlay():boolean[] {
        return this._initialStackOverlay;
    }

    public get stackOverlay():boolean[][] {
        return this._stackOverlay;
    }

    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    public get doScatterNudge():boolean[] {
        return this._doScatterNudge;
    }

    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    public get stackedModeSymbolInWin():boolean[] {
        return this._stackedModeSymbolInWin;
    }

    constructor(rawData:IWildNudgeGameData, dataParser:WildNudgeServerDataParser) {
        super(rawData, dataParser);

        this._stackedSpinTriggered = dataParser.parseStackedSpinTriggered(rawData);
        this._activeStackedSymbol = dataParser.parseActiveStackedSymbol(rawData);
        this._initialStackOverlay = dataParser.parseInitialStackOverlay(rawData);
        this._stackOverlay = dataParser.parseStackOverlay(rawData);
        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._doScatterNudge = dataParser.parseDoScatterNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);
        this._stackedModeSymbolInWin = dataParser.parseStackedModeSymbolInWin(rawData);
    }
}